import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { SegmentComponent } from './segments.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.SEGMENTS' };
var routes = [
    {
        path: 'segmentos',
        component: SegmentComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var SegmentsModule = /** @class */ (function () {
    function SegmentsModule() {
    }
    return SegmentsModule;
}());
export { SegmentsModule };
export { ɵ0 };
